
function Home() {
  return (
    <div>
      <img src="/bca-logo.png" height={400} width={400}></img>
    </div>
  )
}

export default Home;